import {
  Button,
  Card,
  Chip,
  Divider,
  Grid,
  Link,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import { useState, useEffect } from "react";

import AttachedDocuments from "../../components/AttachedDocuments";
import EvaluationHistory from "./EvaluationHistory";

const EvaluationContentCard = ({
  evaluation,
  onUpdate,
  refreshKey,
  getEvaluationByID,
  user,
  queues,
}) => {
  const [currentEvaluation, setCurrentEvaluation] = useState(evaluation);
  const [viewHistory, setViewHistory] = useState(false);

  useEffect(() => {
    setCurrentEvaluation(evaluation);
  }, [evaluation, refreshKey]);

  const getStatusColor = (status) => {
    switch (status) {
      case "Failed":
        return "error";
      case "Completed":
        return "success";
      case "Busy":
        return "warning";
      case "Cancelled":
        return "default";
      default:
        return "info";
    }
  };

  const StatusSection = () => {
    return (
      <div
        style={{
          display: "flex",
          gap: "8px",
          alignItems: "center",
        }}
      >
        <Chip
          variant="outlined"
          color={getStatusColor(currentEvaluation.status)}
          label={currentEvaluation.status}
        />
      </div>
    );
  };

  return (
    <Card>
      <List dense>
        <Divider />
        <ListItem secondaryAction={<StatusSection />}>
          <ListItemText
            primary={
              <>
                <Typography
                  sx={{ display: "inline" }}
                  component="span"
                  variant="body2"
                  color="text.secondary"
                >
                  Person being evaluated
                </Typography>
              </>
            }
            secondary={
              <>
                <Typography
                  sx={{ display: "inline" }}
                  component="span"
                  variant="body1"
                  color="text.primary"
                >
                  {currentEvaluation?.evaluation_users?.name}{" "}
                  {currentEvaluation?.evaluation_users?.surname}
                </Typography>
              </>
            }
          />
        </ListItem>
        <Divider />
        <Grid container>
          <Grid item xs={4}>
            {queues && queues[0] && queues[0].campaign && (
              <ContentItem
                title="Campaign Name"
                value={queues[0].campaign.name}
              />
            )}
            <ContentItem
              title="Queue Name"
              value={currentEvaluation?.campaign?.name}
            />
            <ContentItem
              title="Unique Id"
              value={currentEvaluation?.unique_id}
            />
            <ContentItem
              title="Assigned to QA Analyst"
              value={`${currentEvaluation?.evaluation_qa_users?.name} ${currentEvaluation?.evaluation_qa_users?.surname}`}
            />
            <ContentItem
              title="Evaluation Type"
              value={currentEvaluation?.evaluation_type}
            />
            <ContentItem
              title="Disposition"
              value={currentEvaluation?.disposition}
            />
            <ContentItem title="Link" link={currentEvaluation?.Link} />
          </Grid>
          <Grid item xs={4}>
            <ContentItem
              title="Start Time"
              value={
                currentEvaluation?.start_time &&
                new Date(currentEvaluation?.start_time).toLocaleDateString(
                  "en-GB",
                ) +
                  " " +
                  new Date(currentEvaluation?.start_time).toLocaleTimeString(
                    "en-GB",
                  )
              }
            />
            <ContentItem
              title="End Time"
              value={
                currentEvaluation?.end_time &&
                new Date(currentEvaluation?.end_time).toLocaleDateString(
                  "en-GB",
                ) +
                  " " +
                  new Date(currentEvaluation?.end_time).toLocaleTimeString(
                    "en-GB",
                  )
              }
            />
            <ContentItem
              title="Tracked Time"
              value={
                currentEvaluation?.time_tracking &&
                currentEvaluation?.time_tracking?.time
              }
            />
            <ContentItem
              title="Languages"
              value={currentEvaluation?.language?.map((language) => {
                return `${language}, `;
              })}
            />
          </Grid>
          <Grid item xs={4}>
            <AttachedDocuments
              evaluation={evaluation}
              getEvaluationByID={getEvaluationByID}
            />
          </Grid>

          <Card sx={{ m: 1 }}>
            {viewHistory ? (
              <Button
                onClick={() => {
                  setViewHistory(!viewHistory);
                }}
              >
                Close History
              </Button>
            ) : (
              <Button
                onClick={() => {
                  setViewHistory(!viewHistory);
                }}
              >
                View Evaluation History
              </Button>
            )}
            {viewHistory && (
              <Grid item xs={12}>
                {evaluation?.history_evaluation?.length > 0 && (
                  <EvaluationHistory
                    evaluationHistoryData={evaluation?.history_evaluation}
                  />
                )}
              </Grid>
            )}
          </Card>
        </Grid>
      </List>
    </Card>
  );
};

export default EvaluationContentCard;

const ContentItem = ({ title, value, link }) => {
  return (
    <>
      <ListItem alignItems="flex-start">
        <ListItemText
          primary={
            <>
              <Typography
                sx={{ display: "inline" }}
                component="span"
                variant="body2"
                color="text.secondary"
              >
                {title}
              </Typography>
            </>
          }
          secondary={
            <>
              {link ? (
                <Link
                  href={link}
                  target="_blank"
                  color="inherit"
                  sx={{ display: "inline" }}
                >
                  {link}
                </Link>
              ) : (
                <Typography
                  sx={{ display: "inline" }}
                  component="span"
                  variant="body1"
                  color="text.primary"
                >
                  {value}
                </Typography>
              )}
            </>
          }
        />
      </ListItem>
    </>
  );
};
